





















































































































































































import Vue from 'vue'
import { mapState, mapActions } from 'vuex'
import style from './style.module.scss'
import dadataStyle from '../../../../styles/dadata.scss'
import config from '../../../../config'

import radio from '@/components/controls/radio/radio.vue'
import buttonRed from '@/components/common/click/button/button-red.vue'
import textInput from '@/components/controls/text-input/text-input.vue'
import textArea from '@/components/controls/text-area/text-area.vue'
import okatoSelector from './okato-selector/okato-selector.vue'
import vueSuggestions from 'vue-suggestions'

import { Calendar } from "anresh-vue"
import { Modal } from "anresh-vue"
import { ButtonRed } from "anresh-vue"
import { IconClose } from "anresh-vue"
import { ButtonClean } from "anresh-vue"

import loader from '@/components/common/loader/loader.vue'
import overlay from '@/components/common/loader/overlay.vue'

import files from './files/files.vue'

import selectSimple from '@/components/controls/select/select-simple.vue'

import { Project, ProjectItem, FieldErrorModel } from '@/types/supplier-search'
import { OkatoModel, TimeZoneItem, ListItem } from '@/types/common'
import { yandexMetrika } from '../../supplier-search/yandex-metrika-mixin'

interface ListModel {
    id: number;
    value: string;
}

export default Vue.extend({
    name: 'supplier-search-step-two',
    mixins: [yandexMetrika],
    components: {
        radio,
        buttonRed,
        textInput,
        textArea,
        selectSimple,
        files,
        vueSuggestions,
        loader,
        overlay,
        Calendar,
        Modal,
        ButtonRed,
        IconClose,
        ButtonClean,
        okatoSelector
    },
    data() {
        return {
            style: style,
            dadataStyle: dadataStyle,
            config: config,
            workFlowType: 'new',
            deliveryType: 'pickup',
            paymentType: 'postpay',
            conditionText: '',
            loading: false,
            projectNameError: {
                error: false,
                message: ''
            } as FieldErrorModel,
            applicationEndDateInnerError: {
                error: false,
                message: ''
            } as FieldErrorModel,
            deliveryAddressInnerError: {
                error: false,
                message: ''
            } as FieldErrorModel,
            showWarning: false,
            selectorOkatoIsOpen: false,
            okatoError: {
                error: false,
                message: ''
            } as FieldErrorModel,
            okatoList: [] as OkatoModel[],
            timeZoneList: [] as ListItem[],
            timeZone: {} as ListItem
        }
    },
    methods: {
        ...mapActions(
            ['getTimeZones']
        ),
        updateDate(data: Date) {
            this.currentProject.ApplicationEndDateInner = data;
        },
        changeIsNewProject($event: boolean) {

            this.$store.commit('setIsNewProject', $event)

            this.setProjectIfExist()
        },
        setProjectIfExist() {
            if(this.projectsForSelect.length > 0) {
                this.selectProject(this.projectsForSelect[0].id.toString())
            }
        },
        async sendProject() {
            if(!this.validate()) return;
            (this as any).sendToYandexMetrikaTtCreateRequest();

            if (!this.isAuthentificated) {
                this.$emit('forward');
            }
            else if (!this.isNewProject &&
                     (this.originChangedProject.PurchaserTermsType != this.currentProject.PurchaserTermsType  ||
                     this.originChangedPosition.DeliveryAddress != this.currentPosition.DeliveryAddress ||
                     this.originChangedProject.Properties.Delivery != this.currentProject.Properties.Delivery ||
                     this.originChangedProject.Properties.Prepayment != this.currentProject.Properties.Prepayment ||
                     this.originChangedProject.Additional.Text != this.currentProject.Additional.Text ||
                     this.originChangedProject.Additional.Files != this.currentProject.Additional.Files))
            {
                this.showWarning = true;
            }
            else {
                this.loading = true;
                if(this.isNewProject) {
                    await this.$store.dispatch('saveProject')
                } else {
                    await this.$store.dispatch('updateProject')
                }

                this.loading = false;
                this.$store.dispatch('getProjectsInfo')
                this.$emit('saved');
                this.emitSentEvent();
                this.resetBudget();
            }
        },
        async updateProject(){
            this.showWarning = false;
            this.loading = true;
            await this.$store.dispatch('updateProject')

            this.loading = false;
            this.$store.dispatch('getProjectsInfo')
            this.$emit('saved');
            this.emitSentEvent();
            this.resetBudget();
        },
        validate(): boolean {
            let result = true;

            if(!this.currentProject.Name) {
                this.projectNameError.error = true;
                this.projectNameError.message = 'Поле должно быть заполнено'
                result = false;
            }

            if (!this.currentProject.ApplicationEndDateInner) {
                this.applicationEndDateInnerError.error = true;
                this.applicationEndDateInnerError.message = 'Поле должно быть заполнено'
                result = false;
            }

            if (!this.currentPosition.DeliveryAddress) {
                this.deliveryAddressInnerError.error = true;
                this.deliveryAddressInnerError.message = 'Поле должно быть заполнено';
                result = false;
            }

            const date = new Date();
            if (this.currentProject.ApplicationEndDateInner && Date.parse(this.currentProject.ApplicationEndDateInner.toString()) < Date.parse(date.toString())) {
                this.applicationEndDateInnerError.error = true;
                this.applicationEndDateInnerError.message = 'Дата должна быть в будущем'
                result = false;
            }
            if (!this.currentPosition.DeliveryAddressOkato){
                this.okatoError.error = true;
                this.okatoError.message = 'Нам не удалось определить регион поставки. Выберите регион из списка';
                return false;
            }

            return result;
        },
        handler(data: string): void {
            this.workFlowType = data
        },
        selectProject(projectId: string) {

            if(projectId === "-1") {
                this.$store.commit('setDefaultProject');
            }

            const id = parseInt(projectId);

            if(!isNaN(id)) {
                const project = this.projects.find((item: Project) => item.Id == id);

                this.$store.dispatch('updateCurrentProject', project);
            }
        },
        emitSentEvent() {
            if (window.supplierSearchEventBus) {
                window.supplierSearchEventBus.$emit('requestSent');
            }
        },
        getDadataOptions(type: string) {
            const store =  this.$store;
            return {
                token: this.config.dadataToken,
                type: type,
                async onSelect (suggestion: any) {
                    const okatos =  store.getters.okatoList as OkatoModel[];
                    if (!okatos || okatos.length == 0){
                        // await store.dispatch('getOkatoList');
                    }
                    if(suggestion && suggestion.data && suggestion.data.region_kladr_id)
                    {
                        const selectedRegion = store.getters.okatoList.filter((s: OkatoModel) => s.Code.includes(suggestion.data.region_kladr_id))
                        if(selectedRegion && selectedRegion.length > 0){
                            store.commit('setOkato', selectedRegion[0]);
                        }
                        else
                        {
                            store.commit('setOkato', { Okato: null });
                        }
                    }
                    else
                    {
                        store.commit('setOkato', { Okato: null });
                    }
                }
            }
        },
        resetBudget() {
            this.$store.dispatch('setCurrentPositionPrice', 0);
            this.$store.dispatch('setCurrentPositionBudget', 0);
        },
        okatoSelectorToggle(isOpen: boolean) {
            this.selectorOkatoIsOpen = isOpen

            return isOpen;
        },
        selectOkato(data: OkatoModel) {
            this.$store.commit('setOkato', data);
        },
        resetDeliveryAddresOkato() {
            this.currentPosition.DeliveryAddressOkato = '';
        },
        selectTimeZone(val: string) {
            if (val){
                const id = Number.parseInt(val);
                this.timeZone = this.timeZoneList.filter((item) => item.id == id)[0];
                this.currentProject.ApplicationEndDateTimeZoneId = this.timeZone.id;
            }
        }
    },
    computed: {
        ...(mapState<RootStateSupplierSearch>({
            currentProject(state: RootStateSupplierSearch): Project {
                return state.currentProject;
            },
            currentPosition(state: RootStateSupplierSearch): ProjectItem {
                return state.currentPosition;
            },
            supplierOrganization(state: RootStateSupplierSearch) {
                return state.supplierOrganization;
            },
            customerOrganization(state: RootStateSupplierSearch) {
                return state.customerOrganization;
            },
            isNewProject(state: RootStateSupplierSearch) {
                return state.isNewProject;
            },
            isNewPosition(state: RootStateSupplierSearch) {
                return state.isNewPosition;
            },
            originChangedProject(state: RootStateSupplierSearch) {
                return state.originChangedProject;
            },
            originChangedPosition(state: RootStateSupplierSearch): ProjectItem {
                return state.originChangedPosition;
            },
        }) as MapStateToComputed<RootStateSupplierSearch>),
        notOriginMode(): boolean {
            return this.$store.getters.notOriginModeType;
        },
        projects(): Project[] {
            return this.$store.getters.projectsForSelect;
        },
        projectsForSelect(): ListModel[] {
            const list = this.$store.getters.projectsForSelect.map((item: Project) => {
                return {
                    id: item.Id,
                    value: item.Name
                }
            });

            return list;
        },
        isAuthentificated(): boolean {
            return this.$store.getters.isAuthentificated;
        },
        okatoValue(): OkatoModel {
            const okatoValue: OkatoModel =
            {
                FullName: '',
                Code: '',
                Okato: ''
            }
            const okatos =  this.$store.getters.okatoList as OkatoModel[];

            if (this.currentPosition.DeliveryAddressOkato)
            {
                if (!okatos || okatos.length == 0){
                    okatoValue.Okato = this.currentPosition.DeliveryAddressOkato;
                }
                else {
                    const currentValue = this.$store.getters.okatoList.filter((s: OkatoModel) => s.Okato.includes(this.currentPosition.DeliveryAddressOkato)) as OkatoModel[];
                    if(currentValue && currentValue.length > 0)
                    {
                        okatoValue.Code = currentValue[0].Code;
                        okatoValue.FullName = currentValue[0].FullName;
                        okatoValue.Okato = currentValue[0].Okato;
                    }
                }
            }
            return okatoValue;
        }
    },
    watch: {
        'currentProject.ApplicationEndDateInner'() {
            if(this.currentProject.ApplicationEndDateInner) {
                this.applicationEndDateInnerError.error = false;
                this.applicationEndDateInnerError.message = ''
            }
        },
        'currentProject.Name'() {
            if(this.currentPosition.Name) {
                this.projectNameError.error = false;
                this.projectNameError.message = ''
            }
        },
        'currentPosition.DeliveryAddress'() {
            if (this.currentPosition.DeliveryAddress || this.currentProject.PurchaserTermsType == 2) {
                this.deliveryAddressInnerError.error = false;
                this.deliveryAddressInnerError.message = '';
            }
        },
        'currentProject.PurchaserTermsType'() {
            if (this.currentPosition.DeliveryAddress || this.currentProject.PurchaserTermsType == 2) {
                this.deliveryAddressInnerError.error = false;
                this.deliveryAddressInnerError.message = '';
            }
        },
        'currentPosition.DeliveryAddressOkato'() {
            if (this.currentPosition.DeliveryAddressOkato || this.currentProject.PurchaserTermsType == 2) {
                this.okatoError.error = false;
                this.okatoError.message = '';
            }
        },
    },
    async mounted () {
        if (this.timeZoneList == null || this.timeZoneList.length == 0){
            this.timeZoneList = (await this.getTimeZones()).data.map((item: TimeZoneItem) => {
                return {
                    id: item.Id,
                    value: item.ShortName,
                }
            });
        }
    }
})
